export type WellsInterventionImporter = {
    wellId: string
    rigId: string
    interventionId: string
    deleteStaticData: string
}

export const api = {
    wellsInterverntionImporter: async (data: WellsInterventionImporter): Promise<any> => {
        return fetch('/services/plugin-static-data-manager/intervention/wells-intervention-importer', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}
